import { hooks } from '@bitrise/bitkit';
import { VizContext } from '@bitrise/bitviz';
import { SessionSpan } from '@trace/types';
import React, { memo, useContext, useState } from 'react';
import SessionTraceVisualisationSpan, {
  SIZE_GAP,
  SIZE_HEIGHT_EXPANDED,
} from './SessionTraceVisualisationSpan';
import './SessionTraceVisualisationSpans.css';

const { useEventListener } = hooks;

interface Props {
  spans: SessionSpan[];
}

const getRenderIndices = (
  winHeight: number,
  winScrollY: number,
  bounds: DOMRect | null,
): [number, number | undefined] => {
  if (!bounds) {
    return [0, undefined];
  }

  const winTop = bounds.top + winScrollY;
  const winDist = Math.max(0, winScrollY - winTop);
  const count = Math.floor((winHeight * 3) / (SIZE_HEIGHT_EXPANDED + SIZE_GAP));
  const countPre = Math.max(0, Math.floor(winDist / (SIZE_HEIGHT_EXPANDED + SIZE_GAP) - count / 4));

  return [countPre, countPre + count];
};

const SessionTraceVisualisationSpans = (props: Props) => {
  const { spans } = props;
  const { ref } = useContext(VizContext);
  const [winHeight, setWinHeight] = useState(window.innerHeight);
  const [winScrollY, setWinScrollY] = useState(window.scrollY);
  const bounds = ref.current && ref.current.getBoundingClientRect();
  const [indexFrom, indexTo] = getRenderIndices(winHeight, winScrollY, bounds);

  useEventListener(
    window,
    'scroll',
    () => {
      if (winScrollY !== window.scrollY) {
        setWinScrollY(window.scrollY);
      }
    },
    [],
  );

  useEventListener(
    window,
    'resize',
    () => {
      if (winHeight !== window.innerHeight) {
        setWinHeight(window.innerHeight);
      }
    },
    [],
  );

  return (
    <g className="TraceSpans">
      {spans.slice(indexFrom, indexTo).map((span, index) => (
        <SessionTraceVisualisationSpan
          index={indexFrom + index}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          span={span}
        />
      ))}
    </g>
  );
};

export default memo(SessionTraceVisualisationSpans);
